import { render, staticRenderFns } from "./SliderLarge.vue?vue&type=template&id=244922b8"
import script from "./SliderLarge.vue?vue&type=script&lang=js"
export * from "./SliderLarge.vue?vue&type=script&lang=js"
import style0 from "./SliderLarge.vue?vue&type=style&index=0&id=244922b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports